// export default function indianNumberFormatComponent ( num ) {

//     num = num.toString();
//     let lastThree = num.slice(-3);
//     let otherNumbers = num.slice(0, -3);

//     if (otherNumbers !== '') {
//         otherNumbers = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
//         return otherNumbers + ',' + lastThree;
//     } else {
//         return lastThree;
//     }
// }

export default function indianNumberFormatComponent(num) {
    if (num == null || isNaN(num)) return '';

    // Always format to two decimal places
    const fixedNum = Number(num).toFixed(2);

    const [integerPart, decimalPart] = fixedNum.toString().split('.');

    let sign = '';
    let int = integerPart;

    // Handle negative numbers
    if (int.startsWith('-')) {
        sign = '-';
        int = int.slice(1);
    }

    const lastThree = int.slice(-3);
    let otherNumbers = int.slice(0, -3);

    if (otherNumbers !== '') {
        otherNumbers = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
        int = otherNumbers + ',' + lastThree;
    } else {
        int = lastThree;
    }

    return sign + int + (decimalPart && decimalPart != '00' ? '.' + decimalPart : '');
}
